import VehicleModal from '../../components/VehicleModal.vue';
import Vue from 'vue';
const vehicleModal = (editMode, requireMassive, vehicle, infoDrivers, dataVehicleTypeExtra, tags, groups, callback) => {
  const vm = new Vue({
    ...VehicleModal,
    propsData: { editMode, requireMassive, vehicle, infoDrivers, dataVehicleTypeExtra, tags, groups, callback },
  });
  vm.$mount();
  vm.$bvModal.show('crud-vehicle-modal');
};
export default vehicleModal;
